import React from 'react';

const InfoCircle: React.FC = () => {
  return (
    <svg
      height="24px"
      width="24px"
      viewBox="0 0 24 24"
      style={{ fill: '#4b585d' }}
    >
      <path
        d="M12 4c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zm0 1.2c-3.756 0-6.8 3.044-6.8 6.8s3.044 6.8 6.8 6.8 6.8-3.044 6.8-6.8-3.044-6.8-6.8-6.8zm0 3c.442 0 .8.358.8.8 0 .442-.358.8-.8.8-.442 0-.8-.358-.8-.8 0-.442.358-.8.8-.8zm0 2.667c.331 0 .6.268.6.6v4.4c0 .331-.269.6-.6.6-.331 0-.6-.269-.6-.6v-4.4c0-.332.269-.6.6-.6z"
        transform="translate(-318 -84) translate(24 24) translate(0 48) translate(294 12)"
      />
    </svg>
  );
};

export default InfoCircle;
